






















import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator'
import { ICatalogCategoryItem } from '~/assets/interfaces/catalog'
import MixinGeneral from '~/assets/mixins/general'

// Подразделы над товарами — один ряд: на последнем месте вместо раздела
// плитка «Показать все», по клику раскрываются все. С expanded — сразу
// все, без плитки: для раздела, где кроме подразделов ничего нет.
@Component({
  components: {
    ComponentCatalogCategoryItem: () =>
      import('~/components/catalog/category/category-item.vue'),
  },
})
export default class ComponentCatalogSections extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] })
  readonly items!: ICatalogCategoryItem[]

  // Сколько плиток в ряду.
  @Prop({ type: Number, default: 5 }) readonly columns!: number

  @Prop({ type: Boolean, default: false }) readonly expanded!: boolean

  private isExpanded = false

  // Пришёл другой список (ушли в другой раздел) — снова сворачиваем.
  @Watch('items')
  private itemsHandler() {
    this.isExpanded = false
  }

  private get isCollapsed() {
    return (
      !this.expanded && !this.isExpanded && this.items.length > this.columns
    )
  }

  private get itemsRender() {
    return this.isCollapsed ? this.items.slice(0, this.columns - 1) : this.items
  }

  private get hiddenAmount() {
    return this.isCollapsed ? this.items.length - this.itemsRender.length : 0
  }

  private get styleGrid() {
    return { gridTemplateColumns: `repeat(${this.columns}, minmax(0, 1fr))` }
  }
}
